import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RegistroPersonasEmpresasLibModule } from '@rpe/registro-personas-empresas-lib';
import { SharedModule } from '../../shared/shared.module';

import { EntityMuestreadorFormContainerComponent } from './entity-muestreador/components/entity-muestreador-form-container/entity-muestreador-form-container.component';
import { MuestreadorFormComponent } from './entity-muestreador/components/muestreador-form/muestreador-form.component';
import { EntityTecnicoResponsableAcreditacionDialogFormContainerComponent } from './entity-tecnico-responsable/components/entity-tecnico-responsable-acreditacion-dialog-form-container/entity-tecnico-responsable-acreditacion-dialog-form-container.component';
import { EntityTecnicoResponsableFormContainerComponent } from './entity-tecnico-responsable/components/entity-tecnico-responsable-form-container/entity-tecnico-responsable-form-container.component';

import { TecnicoResponsableAcreditacionFormComponent } from './entity-tecnico-responsable/components/tecnico-responsable-acreditacion-form/tecnico-responsable-acreditacion-form.component';
import { TecnicoResponsableFormComponent } from './entity-tecnico-responsable/components/tecnico-responsable-form/tecnico-responsable-form.component';
import { TecnicoFormComponent } from './entity-tecnicos/components/tecnico-form/tecnico-form.component';
import { RolesRoutingModule } from './roles-routing.module';
import { VistaMuestreadorContainerComponent } from './vista-muestreador/components/vista-muestreador-container/vista-muestreador-container.component';
import { VistaTecnicoResponsableContainerComponent } from './vista-tecnico-responsable/components/vista-tecnico-responsable-container/vista-tecnico-responsable-container.component';
import { ConsentimientoInformadoComponent } from './consentimiento-informado/consentimiento-informado.component';
import { IntegranteFormComponent } from './integrante/integrante-form/integrante-form.component';
import { NuevoVinculoFormComponent } from './nuevo-vinculo-form/nuevo-vinculo-form.component';
import { RolDetailComponent } from './rol-detail/rol-detail.component';
import { VinculacionRolActividadListadoComponent } from './vinculacion-rol-actividad-listado/vinculacion-rol-actividad-listado.component';
import { PersonaModule } from '../persona/persona.module';
import { EntityRolFormContainerComponent } from './entity-roles/components/entity-rol-form-container/entity-rol-form-container.component';
import { EntityVinculoLaboralFormContainerComponent } from './entity-roles/components/entity-vinculo-laboral-form-container/entity-vinculo-laboral-form-container.component';
import { VinculacionRolActividadFormDialog } from './entity-roles/components/vinculacion-rol-actividad-form-dialog/vinculacion-rol-actividad-form-dialog.component';
import { EffectsModule } from '@ngrx/effects';
import { RolEffects } from './entity-roles/entity-roles.effects';
import { VistaIntegranteContainerComponent } from '../vista-integrante/components/vista-vinculo-container/vista-integrante-container.component';
import { EntityIntegranteFormContainerComponent } from './entity-integrante/components/entity-nuevo-integrante-form-container/entity-integrante-form-container.component';
import { VistaVinculosContainerComponent } from '../vista-vinculos/components/vista-vinculos-container/vista-vinculos-container.component';
import { VinculoLaboralSeccionComponent } from './entity-roles/components/vinculo-laboral-seccion/vinculo-laboral-seccion.component';
import { VistaNuevoVinculoContainerComponent } from '../vista-nuevo-vinculo/components/vista-nuevo-vinculo-container/vista-nuevo-vinculo-container.component';
import { EmpresasModule } from '../empresas/empresas.module';
import { UbicacionesModule } from '../ubicaciones/ubicaciones.module';
import { ContactosModule } from '../contactos/contactos.module';

@NgModule({
  declarations: [
    TecnicoFormComponent,
    TecnicoResponsableFormComponent,
    TecnicoResponsableAcreditacionFormComponent,
    EntityTecnicoResponsableFormContainerComponent,
    EntityTecnicoResponsableAcreditacionDialogFormContainerComponent,
    MuestreadorFormComponent,
    EntityMuestreadorFormContainerComponent,
    VistaMuestreadorContainerComponent,
    VistaTecnicoResponsableContainerComponent,
    ConsentimientoInformadoComponent,
    IntegranteFormComponent,
    NuevoVinculoFormComponent,
    RolDetailComponent,
    VinculacionRolActividadListadoComponent,
    EntityRolFormContainerComponent,
    EntityVinculoLaboralFormContainerComponent,
    VinculacionRolActividadFormDialog,
    VistaIntegranteContainerComponent,
    EntityIntegranteFormContainerComponent,
    VistaVinculosContainerComponent,
    VinculoLaboralSeccionComponent,
    VistaNuevoVinculoContainerComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    SharedModule,
    RegistroPersonasEmpresasLibModule,
    RolesRoutingModule,
    UbicacionesModule,
    PersonaModule,
    EmpresasModule,
    ContactosModule,
    EffectsModule.forFeature([RolEffects])
  ],
  exports: [
    TecnicoFormComponent,
    TecnicoResponsableFormComponent,
    TecnicoResponsableAcreditacionFormComponent,
    EntityTecnicoResponsableFormContainerComponent,
    EntityTecnicoResponsableAcreditacionDialogFormContainerComponent,
    MuestreadorFormComponent,
    EntityMuestreadorFormContainerComponent,
    VistaMuestreadorContainerComponent,
    VistaTecnicoResponsableContainerComponent,
    ConsentimientoInformadoComponent,
    IntegranteFormComponent,
    NuevoVinculoFormComponent,
    RolDetailComponent,
    VinculacionRolActividadListadoComponent,
    EntityRolFormContainerComponent,
    EntityVinculoLaboralFormContainerComponent,
    VinculacionRolActividadFormDialog,
    VistaIntegranteContainerComponent,
    EntityIntegranteFormContainerComponent,
    VistaVinculosContainerComponent,
    VinculoLaboralSeccionComponent,
    VistaNuevoVinculoContainerComponent
  ]
})
export class RolesModule {}
